module.exports = __webpack_public_path__ + "media/images/service/n_12-3d8eceb49127758a9ca9872ddcbafb55.jpg";